import React from 'react'

/**
 * Component to display the user's previous plan information
 * @param {Map} props.staticText - Static text translations
 * @param {Map} props.previousPlan - Previous plan data
 */
function CartSinglePagePreviousPlan (props) {
  const { staticText, previousPlan } = props

  // Early return if no previous plan data
  if (!previousPlan) {
    return null
  }

  const previousPlanName = previousPlan.get('title')

  return (
    <div className="winback__previous-plan">
      <div className="winback__previous-plan-label">
        {staticText.getIn(['data', 'previousPlan'])}
      </div>
      <div className="winback__previous-plan-name">{previousPlanName}</div>
    </div>
  )
}

export default CartSinglePagePreviousPlan
